import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from "@mui/icons-material/Upload";
import {
  Backdrop,
  Card,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormControl,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Slider,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";

// location: frontend/qiankun/upstyledpkgs/tui.image-editor-3.15.3
// must yarn remove tui-image-editor @toast-ui/react-image-editor
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import { Select, Upload } from "antd";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";

import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import { AccountContext } from "context/account";
import { nanoid } from "nanoid";
import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";

import colors from "assets/theme/base/colors";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import qs from "query-string";

import InputBase from "@mui/material/InputBase";
import Grid from "@mui/material/Grid";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";

import AIResultView from "pages/unionwear/components/AIResultView";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

import { socket } from "services/request";

import { promptTags, modelMap } from "utils/data";
import { capitalCase } from "capital-case";
import { Empty } from "antd";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

import UnionwearLayout from "pages/unionwear/layout";

const generateNumberMarks = [
  { value: 1, label: 1 },
  { value: 2, label: 2 },
  { value: 3, label: 3 },
  { value: 4, label: 4 },
];

// const fabricOptions = [
//   { value: "fabric-chino_twill", label: "Chino Twill" },
//   { value: "fabric-duck", label: "Duck" },
//   { value: "fabric-mesh", label: "Mesh" },
//   { value: "fabric-wool-serge", label: "Wool Serge" },
// ];

// const colorOptions = [
//   { value: "royal-blue", label: "Royal Blue" },
//   { value: "vegas-gold", label: "Vegas Gold" },
// ];

const optionAll = [
  {
    value: "chino",
    label: "Chino Twill",
    children: [
      {
        value: "red",
        label: "Red",
      },
    ],
  },
  {
    value: "canvas",
    label: "Canvas",
    children: [
      {
        value: "black",
        label: "Black",
      },
      {
        value: "red",
        label: "Red",
      },
      {
        value: "white",
        label: "White",
      },
    ],
  },
  {
    value: "ripstop",
    label: "Ripstop",
    children: [
      {
        value: "black",
        label: "Black",
      },
      {
        value: "red",
        label: "Red",
      },
      {
        value: "Khaki",
        label: "khaki",
      },
    ],
  },
  {
    value: "wool",
    label: "Wool Serge",
    children: [
      {
        value: "black",
        label: "Black",
      },
      {
        value: "red",
        label: "Red",
      },
      {
        value: "Navy Blue",
        label: "navy blue",
      },
    ],
  },
  {
    value: "mesh",
    label: "Mesh",
    children: [
      {
        value: "khaki",
        label: "Khaki",
      },
    ],
  },
  {
    value: "spacermesh",
    label: "Spacer Mesh",
    children: [
      {
        value: "white",
        label: "White",
      },
    ],
  },
];

const TASK_TYPE = "unionwear.xl.canny";

const defaultConfig = {
  task_type: TASK_TYPE,
  prompt: "",
  negative_prompt: "",
  batch_size: 2,
};

const DetailViewProduct = () => {
  const [productData, setProductData] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState();
  const [selectedFabric, setSelectedFabric] = useState(optionAll[0]);
  const [selectedColor, setSelectedColor] = useState(optionAll[0]["children"][0]);

  const [isDirty, setIsDirty] = useState(false);
  const [jobconf, setJobconf] = useState({ ...defaultConfig });
  const [resultData, setResultData] = useState([]);
  const [uploading, setUploading] = useState(false);

  const [runningJob, setRunningJob] = useState("");
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [imgsViewerCurrent, setImgsViewerCurrent] = useState(0);
  const [colorOptions, setColorOptions] = useState([]);

  const pathnames = window.location.pathname.split("/");
  let uwproduct_id = null;
  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "product") {
    uwproduct_id = pathnames[pathnames.length - 1];
  }

  const promptRef = useRef(null);

  const account = useContext(AccountContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (uwproduct_id) {
      retrieveProduct(uwproduct_id);
    } else {
      setResultData([]);
      setJobconf({ ...defaultConfig });
    }
  }, [uwproduct_id]);

  const retrieveProduct = async (id) => {
    try {
      const { data } = await api.uwProduct.retrieve(id);
      let uProduct = data?.uProduct || {};

      setProductData(uProduct);
      setProductImages(uProduct?.content?.images || []);
      if (uProduct?.content?.images?.length > 0) {
        setSelectedImage(uProduct?.content?.images[0]);
      }
      if (uProduct?.ai_result?.results) {
        setResultData(uProduct.ai_result.results);
      }
      if (uProduct?.ai_result?.jobconf) {
        setJobconf(uProduct.ai_result.jobconf);
      }

      //set default fabric option
      let fabric = uProduct?.content?.backs_and_sides_fabric;
      if (fabric) {
        let matchedFabric;
        for (let i = 0; i < optionAll.length; i++) {
          let fabricText = optionAll[i].label.toLowerCase();
          if (fabric.toLowerCase().includes(fabricText)) {
            matchedFabric = optionAll[i];
          }
        }
        if (matchedFabric) {
          setSelectedFabric(matchedFabric);
          let myColorOptions = matchedFabric?.children || [];

          for (let j = 0; j < myColorOptions.length; j++) {
            let colorText = myColorOptions[j].label.toLowerCase();
            if (fabric.toLowerCase().includes(colorText)) {
              setSelectedColor(myColorOptions[j]);
            }
          }
        }
      }
    } catch (err) {
      toast.error(`Retrieve product ${id} failed!`);
      console.log(err);
    }
  };

  const saveAILab = async () => {
    setIsDirty(false);

    var payload = {
      ai_result: { results: resultData },
    };

    await api.uwProduct.update(uwproduct_id, payload);
  };

  useEffect(() => {
    if (isDirty) {
      saveAILab();
    }
  }, [isDirty]);

  const runAIJob = async (newjobconf) => {
    //POST to http://localhost:9008/admin/ai-job

    if (!selectedFabric?.value || !selectedColor?.value) {
      return toast.error("Please select a fabric and color.");
    }

    const promptStr = promptRef?.current?.value?.trim() || "";

    if (promptStr) {
      newjobconf.prompt = promptStr;
    } else {
      newjobconf.prompt = `A ${selectedColor.value}  ${selectedFabric.value} baseball cap, white background.`;
    }

    if (!selectedImage?.url) {
      //all models need a input image except text-to-image
      return toast.error("Please upload/select a image!");
    }

    if (!(newjobconf.batch_size > 0 && newjobconf.batch_size <= 12)) {
      toast.error("Result size should be between 1 and 12");
      return;
    }

    setJobconf(newjobconf);

    try {
      setRunningJob(true);

      var taskData = {
        task_type: TASK_TYPE,
        owner_id: account.id,
        task_meta: {
          product_id: uwproduct_id,
          conditional: selectedImage.url,
          task_type: TASK_TYPE,
          prompt: newjobconf.prompt,
          negative_prompt: newjobconf.negative_prompt,
          batch_size: newjobconf.batch_size,
          max_num_inference_steps: newjobconf.max_num_inference_steps ?? 20,
          num_inference_steps: newjobconf.num_inference_steps ?? 40,
          conditioning_scale: 0.6,
          guidance_scale: 7.5,
          start_at: new Date(),
        },
      };

      const { data } = await api.uwProduct.aiTask(taskData);

      var result = data?.result?.ai_result?.results || [];
      //console.log('taskData', taskData, 'data', data)
      console.log(result);
      setResultData(result);

      setIsDirty(true);
      setRunningJob(false);
    } catch (err) {
      console.log(err);
      toast.error("Error to generate AI results!");
      setRunningJob(false);
    }
  };

  const openImgsViewer = () => setImgsViewerVisible(true);
  const closeImgsViewer = () => setImgsViewerVisible(false);

  const handleFullScreen = (e, url) => {
    if (!url) {
      return;
    }
    const index = productImages.findIndex((x) => x.url == url);
    if (index > -1) {
      setImgsViewerCurrent(index);
      openImgsViewer();
    }
  };

  const handleFabricChange = (v) => {
    setSelectedFabric(v);
    setColorOptions(v?.children || []);
  };

  return (
    <SuiBox>
      <UnionwearLayout>
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Waiting...
          </SuiTypography>
        </Backdrop>
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={Boolean(runningJob)}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Waiting...
          </SuiTypography>
        </Backdrop>

        <Lightbox
          open={imgsViewerVisible}
          close={closeImgsViewer}
          slides={productImages.map((x, index) => ({ src: x.url, id: index }))}
          plugins={[Zoom, Download, Thumbnails]}
          zoom={{ maxZoomPixelRatio: 3 }}
          index={imgsViewerCurrent}
        />

        <SuiBox display="flex" justifyContent="space-between" alignItems="center" gap={1} py={2}>
          <SuiButton
            onClick={() => {
              navigate(-1);
            }}
            variant={"text"}
            color="dark"
          >
            <ArrowBackIcon sx={{ mr: 0.5, width: 18, height: 18 }} />
            Back
          </SuiButton>
          <SuiTypography variant="h5" color="dark" sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}>
            {productData?.name || "Untitled"}
          </SuiTypography>
          <div />
        </SuiBox>

        <SuiBox display="flex">
          <SuiBox
            mx={1}
            mb={2}
            sx={{ pr: 1, borderRight: "1px #e3e3e3 solid", minWidth: 120, maxWidth: 300 }}
          >
            <div
              className="hover-parent"
              style={{
                position: "relative",
                minHeight: 200,
                borderRadius: 12,
                overflow: "hidden",
              }}
            >
              <ImageCardWrapper
                data={selectedImage}
                width={300}
                height={300}
                resizeType="m_mfit"
                sx={{
                  borderRadius: "md",
                  width: "100%",
                  height: "auto",
                  maxHeight: 300,
                  minHeight: 300,
                }}
                onClick={(e) => handleFullScreen(e, selectedImage?.url)}
              />
              <SuiBox
                className="hover-children"
                sx={{ position: "absolute", top: 4, right: 4, left: 4, width: "auto" }}
              >
                <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                  <Tooltip title={"Fullscreen"}>
                    <IconButton
                      size="small"
                      color="dark"
                      sx={{
                        backgroundColor: "#ffffff",
                        "&:hover": {
                          backgroundColor: "#e3e3e3",
                        },
                        border: "1px #e3e3e3 solid",
                      }}
                      onClick={(e) => handleFullScreen(e, selectedImage?.url)}
                    >
                      <FullscreenIcon />
                    </IconButton>
                  </Tooltip>
                </SuiBox>
              </SuiBox>{" "}
            </div>
            <SuiBox
              sx={{ mt: 1, overflow: "auto" }}
              width={"100%"}
              display="flex"
              flexDirectrion="column"
              flexWrap="noWrap"
              gap={1}
            >
              {productImages.map((img) => (
                <SuiBox sx={{ border: "1px #e3e3e3 solid", minWidth: 50 }}>
                  <SuiBox
                    sx={{ cursor: "pointer", minWidth: 50, p: 0.5 }}
                    onClick={() => setSelectedImage(img)}
                  >
                    <ImageCardWrapper
                      data={img}
                      width={50}
                      height={50}
                      sx={{
                        width: "100%",
                        height: "auto",
                        maxHeight: 50,
                      }}
                    />
                  </SuiBox>
                </SuiBox>
              ))}
            </SuiBox>
            <Card sx={{ borderRadius: 1, my: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
              >
                Product Information
              </SuiTypography>
              <SuiBox p={1}>
                <SuiBox>
                  <SuiBox mb={1} ml={0.5} lineHeight={0}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Backs and sides fabric:
                    </SuiTypography>
                    <SuiTypography variant="body1" color="secondary">
                      {productData?.content?.backs_and_sides_fabric}
                    </SuiTypography>
                  </SuiBox>
                  <SuiBox mb={1} ml={0.5} lineHeight={0}>
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Visor fabric:
                    </SuiTypography>
                    <SuiTypography variant="body1" color="secondary">
                      {productData?.content?.visor_fabric}
                    </SuiTypography>
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            </Card>
            <Card sx={{ borderRadius: 1, my: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
              >
                Fabric & Color
              </SuiTypography>
              <SuiBox p={1}>
                <SuiBox>
                  <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Fabric:
                    </SuiTypography>
                  </SuiBox>
                  <SuiSelect
                    options={optionAll}
                    onChange={(v) => handleFabricChange(v)}
                    value={selectedFabric}
                  ></SuiSelect>
                </SuiBox>
                <SuiBox>
                  <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                    <SuiTypography component="label" variant="caption" fontWeight="bold">
                      Color:
                    </SuiTypography>
                  </SuiBox>

                  <SuiSelect
                    options={colorOptions}
                    onChange={(v) => setSelectedColor(v)}
                    value={selectedColor}
                  ></SuiSelect>
                </SuiBox>
              </SuiBox>
            </Card>

            <Card sx={{ borderRadius: 1, my: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 1.6, backgroundColor: "#f3f3f3", px: 1 }}
              >
                Generate Number
              </SuiTypography>
              <SuiBox p={1}>
                <SuiBox mx={2}>
                  <Slider
                    min={1}
                    max={2}
                    step={1}
                    marks={generateNumberMarks}
                    onChange={(e, value) => setJobconf((prev) => ({ ...prev, batch_size: value }))}
                    value={jobconf?.batch_size || 4}
                  />
                </SuiBox>
              </SuiBox>
            </Card>
          </SuiBox>
          <SuiBox sx={{ flex: "1 1 auto", px: 2, my: 2 }}>
            <SuiBox>
              <SuiBox sx={{ minHeight: "50vh" }}>
                {resultData && resultData.length > 0 ? (
                  <AIResultView
                    resultData={resultData}
                    setResultData={setResultData}
                    setIsDirty={setIsDirty}
                    productData={productData}
                  />
                ) : (
                  <Empty />
                )}
              </SuiBox>

              <Paper
                elevation={3}
                sx={{
                  p: 1,
                  my: 2,
                  width: "100%",
                  borderRadius: "8px",
                }}
              >
                <InputBase
                  sx={{ flex: 1, border: "none" }}
                  placeholder="Describe the image you want to generate"
                  inputProps={{ ref: promptRef }}
                  onKeyDown={(e) => {
                    if (e.code == "Enter") {
                      runAIJob({ ...jobconf });
                    }
                  }}
                  multiline
                  maxRows={4}
                  minRows={1}
                />

                <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={0.5}>
                  <SuiButton
                    variant="gradient"
                    color="info"
                    size="small"
                    sx={{
                      display: {
                        xs: "none",
                        sm: "none",
                        md: "flex",
                        lg: "flex",
                        textTransform: "capitalize",
                      },
                      fontSize: 14,
                    }}
                    onClick={() => {
                      runAIJob({ ...jobconf });
                    }}
                  >
                    Generate
                  </SuiButton>
                </SuiBox>
              </Paper>
            </SuiBox>
          </SuiBox>
        </SuiBox>
      </UnionwearLayout>
    </SuiBox>
  );
};

export default DetailViewProduct;
